import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { 
  ActivatedRouteSnapshot, 
  Router, 
  ResolveFn,
} from '@angular/router';
import { UserService } from '../services/user_service';
import { User } from '../types/user';

export const userProfileAtResolver: ResolveFn<User | null> = (
  route: ActivatedRouteSnapshot
) => {
  const platformId = inject(PLATFORM_ID);
  const userService = inject(UserService);
  const router = inject(Router);

  if (isPlatformServer(platformId)) {
    return Promise.resolve(null);
  }
  
  const userName = route.paramMap.get('username');
  
  return userService.getUserProfileByUsername(userName).then((user: User) => {
    return user;
  }).catch(() => {
    router.navigate(['/']);
    return Promise.resolve(null); 
  });
};